module.exports = __webpack_public_path__ + "media/images/designer-5c1c7e929b5216c3561413069b8c9e97.jpg";